import React from 'react';
import styles from './Hero.module.scss';
import Img from 'gatsby-image'

const academyPages = [
    '/academy',
    '/academy/',
    '/academy/interest',
    '/academy/interest/',
    '/academy/experience',
    '/academy/experience/'
]
const Hero = (props) => (
  <div className={`page-hero ${styles.Hero}${academyPages.includes(props.location) || props.admissionsTemplate ? ' academy' : ''}`}>
    <div className={styles.Hero__Wrapper}>
      <div className={styles.Hero__Info}>
        <div className={academyPages.includes(props.location) || props.admissionsTemplate ? styles.Hero__Title__Academy : styles.Hero__Title}>
          <h1 dangerouslySetInnerHTML={{ __html: props.title }} />
        </div>
        <div className="hero-img-wrap">
            <Img sizes={props.featuredImage.sizes} alt={props.featuredImage.title} />
            { props.caption && <p className="small-hero-caption">{props.caption}</p> }
        </div>
        <p>{props.description}</p>
      </div>
    </div>
  </div>
)

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Destination/Hero/index.js